import { colors } from './colors';

Object.entries(colors).forEach(([name, value]) => {
    document.documentElement.style.setProperty(`--${name}`, value);
});
